// =========================================================================
// 1. VARIABLES Y DATOS
// =========================================================================
let ALL_VARIANTS = [];
window.isUpdatingPrice = false;
const IS_CANADA = window.ShopifyCustom && window.ShopifyCustom.isCanada === true;

// Memoria para WiFi
if (typeof window.globalWifiState === 'undefined') {
    window.globalWifiState = null;
}

// Memoria para Protección
if (typeof window.globalProtectionState === 'undefined') {
    window.globalProtectionState = null;
}

function loadVariantsData() {
    const jsonScript = document.getElementById('AllProductVariantsData');
    if (jsonScript && jsonScript.textContent) {
        try {
            ALL_VARIANTS = JSON.parse(jsonScript.textContent);
        } catch (e) {}
    }
}

function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

// =========================================================================
// 2. LÓGICA DE CÁLCULO
// =========================================================================

function calculateCurrentState() {
    if (ALL_VARIANTS.length === 0) loadVariantsData();

    // 1. Leer WiFi
    let isWifiActive = false;
    if (window.globalWifiState !== null) {
        isWifiActive = window.globalWifiState;
    } else {
        const wifiIn = document.querySelector('.custom_wifi\\+uvsanitation input[value="Yes Wifi + UV"]');
        isWifiActive = wifiIn ? wifiIn.checked : false;
    }

    // 2. Leer Variantes Nativas
    const chillerInput = document.querySelector('fieldset.custom_choose input:checked');
    const tubInput = document.querySelector('fieldset.custom_addtub input:checked');

    // 3. Leer Protección (Prioridad a Memoria)
    let isProtectionActive = false;
    if (window.globalProtectionState !== null) {
        isProtectionActive = window.globalProtectionState;
    } else {
        // Fallback inicial
        const protectionInput = document.querySelector('input[name="protection-plan"]:checked');
        isProtectionActive = protectionInput && protectionInput.value === '5-Year';
    }

    const val1 = chillerInput ? chillerInput.value.trim() : '';
    const val2 = isWifiActive ? 'Yes Wifi + UV' : 'No Wifi + UV';
    const val3 = tubInput ? tubInput.value.trim() : '';


    if (IS_CANADA) {
        // --- CONFIGURACIÓN CANADÁ ---
        if (val1.includes("1/2HP")) {
            protectionCost = 24500;
            protectionId = "42885919113252";
            protectionLabel = 245;
        } else if (val1.includes("1HP") || val1.includes("PRO+")) {
            protectionCost = 33000;
            protectionId = "42885926223908";
            protectionLabel = 330;
        } else {
            // Default 1/3HP
            protectionCost = 16500;
            protectionId = "42885917671460";
            protectionLabel = 165;
        }
    } else {
        // --- CONFIGURACIÓN USA (Original) ---
        if (val1.includes("1/2HP")) {
            protectionCost = 14900; protectionId = "42885919113252"; protectionLabel = 149;
        } else if (val1.includes("1HP") || val1.includes("PRO+")) {
            protectionCost = 19900; protectionId = "42885926223908"; protectionLabel = 199;
        } else {
            protectionCost = 9900; protectionId = "42885917671460"; protectionLabel = 99;
        }
    }

    // 5. Buscar Variante
    if (ALL_VARIANTS.length === 0) return null;
    const foundVariant = ALL_VARIANTS.find(v => {
        const o1 = v.option1 ? v.option1.trim() : '';
        const o2 = v.option2 ? v.option2.trim() : '';
        const o3 = v.option3 ? v.option3.trim() : '';
        return o1 === val1 && o2 === val2 && o3 === val3;
    });

   if (!foundVariant) {
    return {
        variantId: null,
        price: 0,
        comparePrice: 0,
        protectionId: null,
        protectionLabel: 0,
        isProtectionActive: false
    };
}


    // 6. Total
    let totalPrice = foundVariant.price;
    if (isProtectionActive) totalPrice += protectionCost;

    return {
        variantId: foundVariant.id,
        price: totalPrice,
        comparePrice: foundVariant.compare_at_price,
        protectionId: protectionId,
        protectionLabel: protectionLabel,
        isProtectionActive: isProtectionActive
    };
}

// =========================================================================
// 3. ACTUALIZADOR DEL DOM
// =========================================================================

function applyUpdatesToDOM() {
    if (window.isUpdatingPrice) return;
    const data = calculateCurrentState();
  if (!data) return;

// allow wifi UI update even without variant


    window.isUpdatingPrice = true;

    // A. RESTAURAR VISUALMENTE LA PROTECCIÓN
    // Si la memoria existe, forzamos el input para que coincida con la memoria
    if (window.globalProtectionState !== null) {
        const radio5 = document.getElementById('protection-5-year');
        const radio2 = document.getElementById('protection-2-year');

        if (window.globalProtectionState === true) {
            if (radio5 && !radio5.checked) radio5.checked = true;
        } else {
            if (radio2 && !radio2.checked) radio2.checked = true;
        }
    }

    // B. Label Protección
    const label5Year = document.getElementById('protection-5-year-label');
 if (label5Year && data.protectionLabel) {
    label5Year.textContent = `5-Year +$${data.protectionLabel}`;
}


    if (data.variantId) {
    const mainIdInput = document.querySelector('input[name="id"]');
    if (mainIdInput && mainIdInput.value != data.variantId) {
        mainIdInput.value = data.variantId;
    }
}


    // D. Precios
  // Only update price when variant exists
if (data.variantId) {

    const formattedPrice = formatMoney(data.price);
    const formattedCompare = data.comparePrice ? formatMoney(data.comparePrice) : '';

    document.querySelectorAll('.price-item--sale, .custom-price, .salepricedk').forEach(el => {
        if (el.textContent.trim() !== formattedPrice) el.textContent = formattedPrice;
    });

    document.querySelectorAll('.price-item--regular, .custom-price1, .salepricerg').forEach(el => {
        const parentS = el.closest('s');

        if (data.comparePrice > data.price) {
            if (el.textContent.trim() !== formattedCompare) el.textContent = formattedCompare;
            if (parentS) parentS.style.display = 'inline';
        } else {
            el.textContent = '';
            if (parentS) parentS.style.display = 'none';
        }
    });

}


    // E. Sincronizar WiFi Visual
    const wifiInput = document.querySelector('.custom_wifi\\+uvsanitation input[value="Yes Wifi + UV"]');
    const switchContainer = document.querySelector('.switch-container');
    const switchButton = document.querySelector('#my-switch');

    if (wifiInput && switchContainer) {
        const shouldBeOn = (window.globalWifiState !== null) ? window.globalWifiState : wifiInput.checked;

        if (shouldBeOn) {
            if (!switchContainer.classList.contains('is-active')) switchContainer.classList.add('is-active');
            if (switchButton) switchButton.setAttribute('aria-checked', 'true');
        } else {
            if (switchContainer.classList.contains('is-active')) switchContainer.classList.remove('is-active');
            if (switchButton) switchButton.setAttribute('aria-checked', 'false');
        }
    }

    setTimeout(() => { window.isUpdatingPrice = false; }, 0);
}

// =========================================================================
// 4. GUARDIÁN DE PRECIOS
// =========================================================================

function setupPriceGuardian() {
    const priceContainer = document.querySelector('.price');
    const stickyPriceContainer = document.querySelector('.product-sticky-form');

    const callback = (mutationsList) => {
        if (window.isUpdatingPrice) return;
        applyUpdatesToDOM();
    };

    const observer = new MutationObserver(callback);
    const config = { childList: true, subtree: true, characterData: true };

    if (priceContainer) observer.observe(priceContainer, config);
    if (stickyPriceContainer) observer.observe(stickyPriceContainer, config);
}

// =========================================================================
// 5. MANEJADORES GLOBALES (DELEGACIÓN DE EVENTOS)
// =========================================================================

// Usamos 'change' a nivel de documento para capturar elementos creados dinámicamente
document.addEventListener('change', function(event) {
    const target = event.target;

    // CASO A: CAMBIO EN LA PROTECCIÓN
    if (target.name === 'protection-plan') {
        event.stopPropagation(); // Evitar que Shopify resetee cosas
        window.globalProtectionState = (target.value === '5-Year');
        applyUpdatesToDOM();
        return;
    }

    // CASO B: CAMBIO EN VARIANTES NATIVAS (Chiller / Tub)
    if (target.matches('fieldset.custom_choose input, fieldset.custom_addtub input')) {
        // Restaurar estado de WiFi si es necesario
        if (window.globalWifiState !== null) {
           const wifiInput = document.querySelector('.custom_wifi\\+uvsanitation input[value^="Yes WiFi"], .custom_appcontrolled\\+uvlight input[value^="Yes App Controlled"]');
const noWifiInput = document.querySelector('.custom_wifi\\+uvsanitation input[value^="No WiFi"], .custom_appcontrolled\\+uvlight input[value^="No App Controlled"]');
            if (window.globalWifiState && wifiInput) wifiInput.checked = true;
            else if (noWifiInput) noWifiInput.checked = true;
        }

        // Restaurar estado de Protección si es necesario
        // (Esto arregla el bug de recarga cuando cambias chiller)
        if (window.globalProtectionState !== null) {
            const radio5 = document.getElementById('protection-5-year');
            const radio2 = document.getElementById('protection-2-year');
            if (window.globalProtectionState) {
                if (radio5) radio5.checked = true;
            } else {
                if (radio2) radio2.checked = true;
            }
        }

        setTimeout(applyUpdatesToDOM, 50);
        return;
    }
});

// Listener para Click en el Switch (WiFi)
// Listener for WiFi Switch
document.addEventListener('click', function(event) {
    const switchContainer = event.target.closest('.switch-container');
    if (!switchContainer || event.target.closest('.tooltip-icon')) return;

    event.preventDefault();
    event.stopPropagation();

   const wifiYes = document.querySelector('.custom_wifi\\+uvsanitation input[value="Yes Wifi + UV"]');
const wifiNo = document.querySelector('.custom_wifi\\+uvsanitation input[value="No Wifi + UV"]');

    const currentState = window.globalWifiState !== null
        ? window.globalWifiState
        : (wifiYes ? wifiYes.checked : false);

    const newState = !currentState;

    // save state
    window.globalWifiState = newState;

    // update radios
    if (newState && wifiYes) wifiYes.checked = true;
    if (!newState && wifiNo) wifiNo.checked = true;

    // 🔥 IMPORTANT: trigger native change so Shopify recalculates variant
    if (wifiYes) {
        wifiYes.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // force recalculation
    setTimeout(() => {
        applyUpdatesToDOM();
    }, 30);
});

// Listener para Click en Protección (Solo para parar burbujeo de click)
document.addEventListener('click', function(event) {
    if (event.target.name === 'protection-plan') {
         event.stopPropagation();
         // No hacemos nada más aquí, dejamos que el evento 'change' maneje la lógica
    }
});


// =========================================================================
// 6. INTERCEPTOR CARRITO
// =========================================================================

function setupCartInterceptor() {
    const addBtns = document.querySelectorAll('button[name="add"], .custom-cart-btn');

    const handleAddToCart = async (e) => {
        let isProtectionSelected = false;
        if (window.globalProtectionState !== null) {
            isProtectionSelected = window.globalProtectionState;
        } else {
            const protectionRadio = document.getElementById('protection-5-year');
            isProtectionSelected = protectionRadio && protectionRadio.checked;
        }

        if (!isProtectionSelected) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        const addBtn = e.currentTarget;
        addBtn.innerText = "Adding...";
        addBtn.disabled = true;
        addBtn.style.opacity = "0.7";

        const data = calculateCurrentState();
        if (!data) { location.reload(); return; }

        const formData = {
            'items': [
                { 'id': data.variantId, 'quantity': 1 },
                { 'id': data.protectionId, 'quantity': 1 }
            ]
        };

        try {
            await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(formData)
            });
            window.location.href = '/cart';
        } catch (err) {
            console.error(err);
            window.location.href = '/cart';
        }
    };

    addBtns.forEach(btn => {
        if (btn.dataset.interceptorActive) return;
        btn.addEventListener('click', handleAddToCart, { capture: true });
        btn.dataset.interceptorActive = "true";
    });
}

// =========================================================================
// 7. INICIALIZACIÓN
// =========================================================================

function init() {
    loadVariantsData();

    // Inicializar memoria WiFi
   const wifiInput = document.querySelector('.custom_wifi\\+uvsanitation input[value="Yes Wifi + UV"]');
    if (window.globalWifiState === null && wifiInput) {
        window.globalWifiState = wifiInput.checked;
    }

    // Inicializar memoria Protección
    const protInput = document.getElementById('protection-5-year');
    if (window.globalProtectionState === null && protInput) {
        window.globalProtectionState = protInput.checked;
    }

    applyUpdatesToDOM();
    setupPriceGuardian();
    setupCartInterceptor();
}

document.addEventListener('DOMContentLoaded', init);
document.addEventListener('shopify:section:load', init);
